import { render, staticRenderFns } from "./PlatformCreatedResumesTotalCountCard.vue?vue&type=template&id=499615e4&"
import script from "./PlatformCreatedResumesTotalCountCard.vue?vue&type=script&lang=js&"
export * from "./PlatformCreatedResumesTotalCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports